/* This class represents a lead of type Free Brochure for a spec. */
export default class SpecBrochureLead {
  constructor(formData) {
    this.specId = formData.id;
    this.comments = formData.comments;
    this.includeRecommendations = formData.includeRecommended;
    this.mailAddress = formData.email;
    this.name = formData.name;
    this.type = 'postSpecBrochure';
    this.userPhoneNumber = formData.phone;
    this.realtorQuestionAnswerId = formData.realtorQuestion;
    this.guid = formData.guid;

    // Represents Free Brochure.
    this.leadAction = formData.leadAction;
    this.fromPage = formData.fromPage;
    this.excludeRecommendations = formData.excludeRecommendations;
    this.preferredContactMethod = formData.preferredContactMethod;

    if (formData.postalCode) {
      this.userPostalCode = formData.postalCode;
    } else {
      this.livesOutside = true;
    }
  }

  setHousingInformation(properties) {
    this.marketId = properties.marketId;
    this.marketName = properties.marketName;
    this.builderName = properties.brandName;
    this.communityName = properties.communityName;
    this.communityId = properties.communityId;
  }
}
